// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"7b53479a","277":"76176e06","296":"a04efe7f","350":"a2922e61","377":"c08afa05","453":"b635982c","489":"24e535e9","526":"a4b39f8c","638":"be76953a","658":"68b61928","688":"f3264006","815":"9eccdd0c","842":"de3a2087","881":"2ad0cb82","886":"9d3005b8","971":"c4a80210"}[chunkId] + ".chunk.js";
};